export default __webpack_public_path__ + "static/media/image47.61f8da80.png";